<template>
  <div class="weather-hourly">
    <EForecastCarousel :is-mobile="isMobile">
      <EForecastItem
        v-for="hour in forecast"
        :key="`${hour.time}`"
        :description="hour.description"
        :code="hour.code"
        :time="hour.time"
        :label="getItemLabel(hour.time)"
        :temperature="hour.temperature"
        :sunrise="sunrise"
        :sunset="sunset"
        data-test-id="forecast-item"
      />
    </EForecastCarousel>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import EForecastCarousel from './carousel';
import EForecastItem from './item';

const timeFormat = { hour: '2-digit', minute: '2-digit' };

export default {
  name: 'EHourlyForecast',
  components: {
    EForecastCarousel,
    EForecastItem,
  },
  props: {
    forecast: {
      type: Array,
      required: true,
    },
    sunrise: {
      type: Date,
      required: true,
    },
    sunset: {
      type: Date,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('global', ['locale']),
  },
  methods: {
    getItemLabel(date) {
      // TODO: do this in the Tile
      return date.toLocaleTimeString(this.locale, timeFormat);
    },
  },
};
</script>

<style lang="scss" scoped>
.weather-hourly {
  padding: $space-1s 0;
}
</style>
